export default class Common {

    static randomString() {
        return Math.random().toString(36).substring(2, 15);
    }

    static error(textValue) {
        Swal.fire({
            icon: 'error',
            title: 'Błąd',
            text: textValue
        });
    }

    static generalError() {
        Swal.fire({
            icon: 'error',
            title: 'Błąd',
            text: 'Spróbuj później'
        });
    }

    static validateToken(token) {
        if (token.trim().length < 8) {
            return 'Proszę podać 8 znaków';
        } else {
            return null;
        }
    }

    static validatePhone(phone) {
        if (phone.trim().length < 9) {
            return 'Proszę podać 9 cyfr';
        } else {
            return null;
        }
    }

    static getLoginCode(phone) {
        let validationError = Common.validatePhone(phone);
        if (validationError) {
            return Promise.reject(validationError);
        }
        return fetch(Common.BASE_API + 'report/' + phone.substr(0, 9)).then(function (response) {
            if (response.ok) {
                return response.json();
            } else {
                return Promise.reject(response);
            }
        });
    }

    static getLoginToken(phoneVal, codeVal) {

        let validationError = Common.validatePhone(phoneVal);
        if (validationError) {
            return Promise.reject(validationError);
        }

        validationError = Common.validatePhone(phoneVal);
        if (validationError) {
            return Promise.reject(validationError);
        }

        return fetch(Common.BASE_API + 'report', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                phone: phoneVal,
                code: codeVal
            })
        }).then(function (response) {
            if (response.ok) {
                return response.json();
            } else {
                return Promise.reject(response);
            }
        });
    }

    static getStats() {
        return fetch(Common.BASE_API + 'report').then(function (response) {
            if (response.ok) {
                return response.json();
            } else {
                return Promise.reject(response);
            }
        });
    }
};

//Common.BASE_API = 'http://localhost:8080/api/';

Common.BASE_API = 'https://app.biokinetica.com/api/';
